const selectors = [
  'grammarly-extension',
  'grammarly-popups',
  'grammarly-card',
  'grammarly-extension-vbars-feedback-form',
  'grammarly-desktop-integration',
  'grammarly-extension-vbar-card',
  'grammarly-extension-vbars',
  '.grammarly-inline-card',
  '.gr-textarea-btn',
  '.grammarly-btn',
];

const rgrm = (): void => {
  const grm = (): void => {
    selectors.forEach((selector) => {
      document
        .querySelectorAll(selector)
        .forEach((element) => element.remove());
    });
  };

  const observer = new MutationObserver(grm);
  observer.observe(document.body, { childList: true, subtree: true });
};

export default rgrm;
